import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selling-point',
  templateUrl: './selling-point.component.html',
  styleUrls: ['./selling-point.component.css']
})
export class SellingPointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/about/selling-point/selling-point.component.ts